import { localRandomUuid } from 'utils/string.utils';
import { TimerSource, TimeEntryStatus } from './types';

export const TIME_ENTRY_WS_EVENT = '.app.models.projects.timeentry';

export type TimeEntryWsAction = 'started' | 'paused' | 'resumed' | 'completed' | 'updated' | 'deleted';

export interface TimeEntryWsPayload {
  ref_token?: string;
  uuid: string;
  source: TimerSource;
  source_uuid: string;
  source_title?: string;
  user_uuid?: string;
  project_uuid?: string;
  minutes?: number;
}

export interface TimeEntryWsEvent {
  id: string;
  action: TimeEntryWsAction;
  payload: TimeEntryWsPayload;
}

export const wsActionToStatus: Record<TimeEntryWsAction, TimeEntryStatus | null> = {
  started: 'running',
  resumed: 'running',
  paused: 'paused',
  completed: 'completed',
  updated: null,
  deleted: null,
};

export const isLocalEcho = (event: TimeEntryWsEvent): boolean => event.payload?.ref_token === localRandomUuid;
